import { render } from "./AdmissionInformation.vue?vue&type=template&id=ac14cc52&ts=true"
import script from "./AdmissionInformation.ts?vue&type=script&lang=ts&external"
export * from "./AdmissionInformation.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__